import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.form = this.el.querySelector('form')
        this.select = this.el.querySelector('select')

        this.selectBind = () => {
            this.form.submit()
        }
        this.select.addEventListener('change', this.selectBind)
    }

    destroy() {
        super.destroy()

        this.select.removeEventListener('change', this.selectBind)
    }
}
